import * as React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

type EncartProps = {
  title?: string;
};

const Encart: React.FC<EncartProps> = ({ title, children }) => {
  return (
    <div className="tw-bg-v_blue-light tw-px-4 tw-py-6 tw-rounded-[18px] tw-relative">
      {
        <div className="tw-absolute tw-text-4xl tw--top-4 tw-font-carrotflower tw-font-normal tw-text-v_blue-dark">
          {title}
        </div>
      }
      <div className={clsx(title ? "tw-pt-4" : "", "tw-font-montserrat")}>
        {children}
      </div>
    </div>
  );
};

Encart.propTypes = {
  //
};

export default Encart;
